import { useEffect, useState } from 'react'
import useSWR from 'swr'

import { fetcher } from '@/lib/fetcher'

type UseMasterNotificationsOptions = {
  enabled?: boolean
}

export function useMasterNotifications({ enabled = true }: UseMasterNotificationsOptions = {}) {
  const [available, setAvailable] = useState(true)

  useEffect(() => {
    setAvailable(Boolean(enabled))
  }, [enabled])

  const shouldFetch = enabled && available

  const { data, error, isLoading, mutate } = useSWR<{ timeline: any[]; hitl: any[]; events: any[] }>(
    shouldFetch ? '/master/notifications' : null,
    fetcher,
    {
      refreshInterval: shouldFetch ? 5000 : 0,
      revalidateOnFocus: shouldFetch,
      onError: (err) => {
        if ((err as { status?: number } | undefined)?.status === 404) {
          setAvailable(false)
        }
      },
    },
  )

  return {
    timeline: data?.timeline ?? [],
    hitl: data?.hitl ?? [],
    events: data?.events ?? [],
    loading: shouldFetch ? Boolean(isLoading) : false,
    error: shouldFetch ? error : null,
    refresh: mutate,
    available: enabled && available,
  }
}
